import {
    FaClock,
    FaEnvelope,
    FaInstagram,
    FaLinkedin,
    FaMapMarkerAlt,
    FaPhone,
    FaWhatsapp,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./../styles/App.css";
import React, { useEffect, useState } from "react";

const Footer = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <footer className="footer">
            <div className="containers">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <h4>Webcrux Technology</h4>
                            {/* <span>Innovate. Create. Elevate.</span> */}
                        </div>
                        <p className="footer-about">
                            We deliver cutting-edge digital solutions tailored
                            to your business needs, helping you stand out in the
                            digital landscape.
                        </p>
                        <div className="social-links">
                            <a
                                href="https://facebook.com/WebcruxTechnology"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <svg
                                    className="social-icon facebook-svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 48 48"
                                    width="40px"
                                    height="40px"
                                >
                                    <path
                                        fill="#0866FF"
                                        d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"
                                    />
                                    <path
                                        fill="#fff"
                                        d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"
                                    />
                                </svg>
                            </a>
                            <a
                                href="https://x.com/WebcruxTech"
                                aria-label="X (formerly Twitter)"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <svg
                                    className="social-icon"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    width="20"
                                    height="20"
                                    style={{ color: "#000000" }}
                                >
                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                </svg>
                            </a>
                            <a
                                href="https://instagram.com/webcrux_technology?igsh=MXRnZnR6b3k1bWhxYQ=="
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <FaInstagram className="social-icon" />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/webcrux-technology/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center justify-center w-12 h-12 rounded-full border border-gray-300 transition-all duration-300 hover:transform hover:-translate-y-1"
                                title="LinkedIn"
                                style={{
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <FaLinkedin
                                    size={22}
                                    className="text-gray-500 group-hover:text-white transition-colors duration-300"
                                />
                            </a>
                            <a
                                href="https://www.youtube.com/@webcruxtechnology"
                                aria-label="YouTube"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                style={{
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <svg
                                    className="social-icon"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    width="24"
                                    height="24"
                                >
                                    <rect
                                        x="2"
                                        y="4"
                                        width="20"
                                        height="16"
                                        rx="4"
                                        fill="#ffffff"
                                    />
                                    <path
                                        d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                                        fill="#ff0000"
                                    />
                                </svg>
                            </a>
                            <a
                                href="https://wa.me/918401181455"
                                aria-label="WhatsApp"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link whatsapp news hover:-translate-y-1"
                                style={{
                                    width: "38px",
                                    height: "38px",
                                }}
                            >
                                <FaWhatsapp className="social-icon" />
                            </a>
                        </div>
                    </div>
                    <div
                        className="footer-section"
                        style={{
                            display: isMobile ? "" : "flex",
                            flexDirection: isMobile ? "" : "column",
                            alignItems: isMobile ? "" : "center",
                        }}
                    >
                        <h4 className="footer-heading">Quick Links</h4>
                        <ul
                            className="footer-links"
                            style={{
                                display: isMobile ? "" : "flex",
                                flexDirection: isMobile ? "" : "column",
                                alignItems: isMobile ? "" : "start",
                                marginLeft: isMobile ? "" : "-3rem",
                            }}
                        >
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/services">Services</a>
                            </li>
                            <li>
                                <a href="/about">About Us</a>
                            </li>
                            <li>
                                <a href="/portfolio">Portfolio</a>
                            </li>
                            <li>
                                <a href="/blog">Blog</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4 className="footer-heading">Our Services</h4>
                        <ul className="footer-links">
                            <li>
                                <a
                                    href="#infra-structure"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/services/#infra-structure");
                                    }}
                                >
                                    Infrastructure
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#cloud-host"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/services/#cloud-host");
                                    }}
                                >
                                    Cloud Hosting
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#Digital-marketing"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(
                                            "/services/#Digital-marketing"
                                        );
                                    }}
                                >
                                    Digital Marketing
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#web-dev"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/services/#web-dev");
                                    }}
                                >
                                    Web Development
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#mobile-dev"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/services/#mobile-dev");
                                    }}
                                >
                                    Mobile App Development
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#ui-ux"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/services/#ui-ux");
                                    }}
                                >
                                    UI/UX Design
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4 className="footer-heading">Contact Info</h4>
                        <ul className="contact-info">
                            <li>
                                <FaMapMarkerAlt className="contact-icon" />
                                <span>Vandemataram,Ahmedabad,382481</span>
                            </li>
                            <li>
                                <FaPhone className="contact-icon" style={{ transform: 'scaleX(-1)' }} />
                                <span><a href="tel:+918401181455" className="custom-link">+91 8401181455</a></span>
                            </li>
                            <li>
                                <FaEnvelope className="contact-icon" />
                                <span><a href="mailto:contact@webcruxtechnology.com" className="custom-link">contact@webcruxtechnology.com</a></span>
                            </li>
                            <li>
                                <FaClock className="contact-icon" />
                                <span>Mon-Fri: 10:00 AM - 07:30 PM</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-legal">
                        <p>
                            &copy; {new Date().getFullYear()} Webcrux Technology
                            All rights reserved
                        </p>
                        {/* <div className="legal-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#cookies">Cookie Policy</a>
            </div> */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
